import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environment/environment';
import { Product } from '../model/product';
import { ProductUtil } from '../util/product.util';

@Injectable({
  providedIn: 'root',
})
export class ProductApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  public getList(): Observable<Product[]> {
    return this.http
      .get<Product[]>(`${this.apiUrl}/products`)
      .pipe(map(products => ProductUtil.groupProductsByPlan(products)));
  }

  public getByApiName(apiName: string): Observable<Product> {
    return this.http.get<Product>(`${this.apiUrl}/products/${apiName}`);
  }
}
